import React, { useState, useEffect, useRef } from "react";
import { ISuccessHeaderProps } from "./SuccessHeader.types";
import { getFlowDataDirect, setFlowDataDirect, useFlowData, FlowTypes } from "@adaptis/flow-components";
import "./SuccessHeader.scss";
import { IPet } from "../../util/common-types";

export default function SuccessHeader(props: ISuccessHeaderProps) {
  const { getData } = useFlowData();
  const [currentPromoCodeType, setCurrentPromoCodeType] = useState<any>("");

  // The policies for a1, a2 & a3 are now set up.
  let allPetNames = getFlowDataDirect("totalAmounts.allPetNames");
  let petQty = getFlowDataDirect("petQty");

  const [
    promoCodeModel,
    setPromoCodeModel,
  ] = useState<FlowTypes.IFlowPromotionCode>();
  const couponModelRef = useRef(promoCodeModel);
  const currentPromoCodeTypeRef = useRef(currentPromoCodeType);

  let message = "";

  if (petQty === 1) {
    message = `The policy for ${allPetNames} is now set up.`;
  } else {
    message = `The policies for ${allPetNames} are now set up.`;
  }

  // Lấy dữ liệu cho Awin1 tracking
  const awc = getFlowDataDirect("awc");
  const orderSubtotal = getFlowDataDirect("totalAmounts.totalPayable") || getFlowDataDirect("totalAmounts.annualPremium") || 0;
  const orderRef = getFlowDataDirect("policyNumber") || getFlowDataDirect("quoteNumber") || "";
  const commissionGroup = "standard"; // Có thể customize dựa trên logic business
  const saleAmount = orderSubtotal;
  const voucherCode = getFlowDataDirect("promoCode") || "";
  const channel = getFlowDataDirect("leadSource") || "PetsyQT";
  const customerAcquisition = getFlowDataDirect("customerId") ? "existing" : "new";

  useEffect(() => {
    couponModelRef.current = promoCodeModel;
  }, [promoCodeModel]);

  useEffect(() => {
    currentPromoCodeTypeRef.current = currentPromoCodeType;
  }, [currentPromoCodeType]);

  function getFirstMonthDiscounted(data: any): number {
    // Tìm đối tượng có giai đoạn chứa tháng đầu tiên (from = 1)
    const firstPeriod = data.find((item: any) => item.from === 1);

    if (!firstPeriod) {
      console.log("Not found period start from month 1");
      return -1;
    }

    // Tổng số tiền cần trả trong giai đoạn
    const { totalPayable, totalBaseAmount, from, to } = firstPeriod;

    // Tính số tiền cần trả cho tháng đầu tiên
    // return totalPayable / totalMonths;
    return totalPayable;
  }

  function getPrices() {
    let sumWasPrice = 0;
    let sumDiscountedPrice = 0;
    let sumFirstMonthPrice = 0;
    let pets = getData("root.pets");

    if (!pets) return 0;

    if (Array.isArray(pets)) {
      pets.forEach((pet: IPet, index: number) => {
        if (pet.customCover) {
          sumWasPrice += pet.customCover?.premiums?.totalPayableBeforeDiscount ?? 0;
          sumDiscountedPrice += pet.customCover?.premiums?.totalPayable ?? 0;
          if (couponModelRef.current && currentPromoCodeTypeRef.current === 2) {
            sumFirstMonthPrice += getFirstMonthDiscounted(pet.customCover?.promo?.policyPremiumInstallmentPayments ?? []);
          } else {
            sumFirstMonthPrice = sumDiscountedPrice / 12;
          }
        }
      });
    }

    return sumFirstMonthPrice;
  }

  // Tạo Awin1 tracking URL
  const getAwin1TrackingUrl = () => {
    if (!awc) return null;

    let amount = getPrices()?.toString() || "0";
    const baseUrl = "https://www.awin1.com/sread.img";
    const params = new URLSearchParams({
      tt: "ns",
      tv: "2",
      merchant: "113270",
      amount,
      cr: "AUD",
      ref: orderRef,
      parts: `${commissionGroup}:${amount}`,
      vc: voucherCode,
      ch: channel,
      customeracquisition: customerAcquisition,
      cks: awc
    });

    return `${baseUrl}?${params.toString()}`;
  };

  const awin1TrackingUrl = getAwin1TrackingUrl();
  console.log('SuccessHeader - awin1TrackingUrl', awin1TrackingUrl);
  React.useEffect(() => {
    // pushDataToGTM("Payment Completed", getGTMQuoteData("Payment Completed"));
    setFlowDataDirect("mmSessionId", "");

    // Awin1 JavaScript tracking - chỉ chạy khi có awc
    if (awc) {
      let amount = getPrices()?.toString() || "0";
      // Tạo script element cho Awin1 tracking
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.innerHTML = `
        //<![CDATA[ /*** Do not change ***/
        var AWIN = AWIN || {};
        AWIN.Tracking = AWIN.Tracking || {};
        AWIN.Tracking.Sale = {};
        /*** Set your transaction parameters ***/
        AWIN.Tracking.Sale.amount = "${amount}";
        AWIN.Tracking.Sale.orderRef = "${orderRef}";
        AWIN.Tracking.Sale.parts = "${commissionGroup}:${amount}";
        AWIN.Tracking.Sale.voucher = "${voucherCode}";
        AWIN.Tracking.Sale.currency = "AUD";
        AWIN.Tracking.Sale.channel = "${channel}";
        AWIN.Tracking.Sale.customerAcquisition = "${customerAcquisition}";
        //]]>
      `;

      // Thêm script vào head
      document.head.appendChild(script);

      console.log('Awin1 JavaScript tracking initialized with awc:', awc);
    }
  }, [awc, orderSubtotal, orderRef, commissionGroup, saleAmount, voucherCode, channel, customerAcquisition]);

  return (
    <>
      <h1
        data-testid="SuccessHeader"
        className="flc_success-header"
        dangerouslySetInnerHTML={{
          __html: message,
        }}
      ></h1>
      {/* Awin1 tracking pixel - chỉ hiển thị khi có awc */}
      {awin1TrackingUrl && (
        <img
          src={awin1TrackingUrl}
          width="0"
          height="0"
          alt="Awin1 tracking pixel"
          style={{ display: 'none' }}
        />
      )}
    </>
  );
}
